export enum SmsType {
  bulk = 'bulk',
  one_to_one = 'one_to_one',
}
